import type { SelectHTMLAttributes } from 'react'

export const SIGNAGE_FONTS = [
  {
    value: 'Hind Siliguri',
    label: 'Hind Siliguri — বাংলা',
    language: 'Bangla',
  },
  {
    value: 'Noto Sans Bengali',
    label: 'Noto Sans Bengali — বাংলা',
    language: 'Bangla',
  },
  { value: 'Anek Bangla', label: 'Anek Bangla — বাংলা', language: 'Bangla' },
  { value: 'Inter', label: 'Inter — English', language: 'English' },
  { value: 'Poppins', label: 'Poppins — English', language: 'English' },
  { value: 'Montserrat', label: 'Montserrat — English', language: 'English' },
] as const

export type SignageFontFamily = (typeof SIGNAGE_FONTS)[number]['value']

export function SignageFontSelect(
  props: Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'>
) {
  return (
    <select
      {...props}
      className={`h-9 w-full rounded-md border bg-background px-3 text-sm ${props.className ?? ''}`}
    >
      {SIGNAGE_FONTS.map((font) => (
        <option
          key={font.value}
          value={font.value}
          style={{ fontFamily: font.value }}
        >
          {font.label}
        </option>
      ))}
    </select>
  )
}
